import titleEnum from "./titleEnum";

export const getTitle = (t, type, args) => {
  switch (type) {
    case titleEnum.LOBBY:
      return args.name;
    case titleEnum.GAME_CREATE:
      return t('TITLE.GAME_CREATE');
    case titleEnum.GAME_LOBBY:
      return t('TITLE.GAME_LOBBY');
    case titleEnum.GAME_OVER:
      return t('TITLE.GAME_OVER');
    case titleEnum.GAME_WAIT_TO_START:
      return t('TITLE.GAME_WAIT_TO_START');
    case titleEnum.GAME_YOUR_TURN:
      return t('TITLE.GAME_YOUR_TURN');
    case titleEnum.GAME_WAIT_TURN:
      return t('TITLE.GAME_WAIT_TURN', { player: args.player });
    case titleEnum.HOME:
      return t('TITLE.HOME');
    default:
      throw Error('Unknown titleEnum: '+type);
  }
}